import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { deleteCategory, resetCategoryState } from '../store/categoryActions';

CategoryDeleteDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  category: PropTypes.object,
};

export default function CategoryDeleteDialog({ open, onClose, category }) {
  const dispatch = useDispatch();
  const { isLoading, isSuccess } = useSelector((state) => state.categoryReducer);

  const handleDelete = async () => {
    if (category) {
      dispatch(deleteCategory(category.id));
    }
  };

  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess, onClose]);

  const handleClose = () => {
    dispatch(resetCategoryState());
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Delete Category</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete "{category?.name}"? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LoadingButton color="secondary" variant="outlined" onClick={handleClose} disabled={isLoading}>
          Cancel
        </LoadingButton>
        <LoadingButton color="error" loading={isLoading} onClick={handleDelete} variant="contained">
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
